// create a react hook that will check local storage for debug_mode parameter

export const useDebugMode = () => {
  const debugMode = localStorage.getItem("debug_mode");
  return debugMode === "true";
};
